/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetVerificationErrorsErrorResponse,
  GetVerificationErrorsResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getEncountersIdentityVerificationErrors = (
  encounterId: number,
  signal?: AbortSignal,
) => {
  return api<GetVerificationErrorsResponse>({
    url: `/api/encounters/${encounterId}/identity-verification/errors`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersIdentityVerificationErrorsQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/identity-verification/errors`] as const;
};

export const getGetEncountersIdentityVerificationErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
  TError = GetVerificationErrorsErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEncountersIdentityVerificationErrorsQueryKey(encounterId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>
  > = ({ signal }) => getEncountersIdentityVerificationErrors(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersIdentityVerificationErrorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>
>;
export type GetEncountersIdentityVerificationErrorsQueryError = GetVerificationErrorsErrorResponse;

export function useGetEncountersIdentityVerificationErrors<
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
  TError = GetVerificationErrorsErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
          TError,
          Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersIdentityVerificationErrors<
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
  TError = GetVerificationErrorsErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
          TError,
          Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersIdentityVerificationErrors<
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
  TError = GetVerificationErrorsErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersIdentityVerificationErrors<
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
  TError = GetVerificationErrorsErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationErrors>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersIdentityVerificationErrorsQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
